import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ns-fixed-element',
    templateUrl: './fixed-element.component.html',
    styleUrls: ['./fixed-element.component.scss']
})
export class FixedElementComponent implements OnInit {

    @Input() public position: 'top' | 'bottom' = 'top';
    @Input() public top: string = null;
    @Input() public left: string = '0px';
    @Input() public right: string = '0px';
    @Input() public bottom: string = null;
    @Input() public zIndex: number = 1;

    constructor(
        private hostElement: ElementRef
    ) { }

    ngOnInit(): void {
        if (this.position === 'top') {
            this.top = '0px';
        }
        if (this.position === 'bottom') {
            this.top = null;
            this.bottom = '0px';
        }

        this.setStyles();
    }

    private setStyles() {
        this.hostElement.nativeElement.style.top = this.top;
        this.hostElement.nativeElement.style.left = this.left;
        this.hostElement.nativeElement.style.right = this.right;
        this.hostElement.nativeElement.style.bottom = this.bottom;

        this.hostElement.nativeElement.style.zIndex = this.zIndex;
    }
}
